import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';

import {BehaviorSubject} from 'rxjs';

import {
    IbanValidatorKey,
    InvalidAmountKey,
    SwiftValidatorKey,
    PhoneValidatorKey,
    EmailValidatorKey,
    AddressValidatorKey,
    MaxDateValidatorKey,
    InArrayValidatorKey,
    MinDateValidatorKey,
    PasswordValidatorKey,
    RequiredValidatorKey,
    FileSizeValidatorKey,
    FileTypeValidatorKey,
    SortCodeValidatorKey,
    MaxLengthValidatorKey,
    OnlyLatinValidatorKey,
    MinLengthValidatorKey,
    TaxNumberValidatorKey,
    ArrayEveryValidatorKey,
    WhitespaceValidatorKey,
    OnlyDigitsValidatorKey,
    EmailExistsValidatorKey,
    LatinDigitsValidatorKey,
    OnlyCyrillicValidatorKey,
    UnderEighteensValidatorKey,
    DuplicatedValueValidatorKey,
    BlackListedCountryValidatorKey,
    NotNullArrayValuesValidatorKey,
    LatinLettersAndSpecialSymbolsAndWhiteSpaceValidatorKey,
    AmountMinValidatorKey,
    AmountMaxValidatorKey, NameValidatorKey, CompanyNameValidatorKey
} from '@spa/validators';

import {ComponentTypesEnum} from '../../enums';
import {BaseControl, Helper} from '../../classes';
import { ExecutionsSymbolValidatorKey, MaximumNumberValidatorKey, MinimumNumberValidatorKey, MaximumAmountValidatorKey } from 'appEntries/panel/validators';

@Component({
    selector: 'app-form',
    templateUrl: './form.component.html',
    styleUrls: ['./form.component.scss']
})
export class FormComponent<FormsControlType = string | number> implements OnInit {
    public componentTypes: typeof ComponentTypesEnum;

    @Input() public form: FormGroup;
    @Input() public observable: BehaviorSubject<BaseControl<FormsControlType>[]>;
    @Input() public hiddenActions: boolean;

    constructor() {
        this.componentTypes = ComponentTypesEnum;
    }

    ngOnInit(): void {
        if (!this.form) {
            this.form = new FormGroup({});
        }

        if (!this.observable) {
            this.observable = new BehaviorSubject([]);
        }

        if (typeof this.hiddenActions === 'undefined') {
            this.hiddenActions = false;
        }
    }

    removeControl(index: number) {
        const removedControls = this.observable.value.splice(index, 1);

        if (removedControls.length > 0) {
            const name = removedControls[0].name;

            this.form.removeControl(name);
        }
    }

    trackByName(index: number, control: BaseControl): string {
        return control.name;
    }

    static getFormMessages(controlLabel?: string, controlLength?: number): { [key: string]: string; } {
        const formatControlLabel = (label: string): string => {
            return !label ? 'The field' : Helper.getCapitalized(label);
        };

        const passwordText =
            () => 'The password must contains minimum 8 symbols, uppercase letter, lowercase letter, special symbol and number';

        const taxNumberText =
            () => 'Invalid tax number. Please double-check that the number entered contains only numbers, upper and lower case letters and/or the symbols “.“, “-“, “/“';

        const getExecutionsSymbolText = () => {
            return `${formatControlLabel(controlLabel)} can contain only latin upper and lower case letters, numbers and/or special symbols “-“, “.“, “$“, “+“, “*“, “#“, “!“, “@“, “^“, “=“, “~“`;
        };
        const companyNameText = () => `Invalid ${formatControlLabel(controlLabel)}. Please double-check that the entered
        ${formatControlLabel(controlLabel)} contains only Latin letters and digits and/or the symbols “.“ , “-“, “ ' “`;

        return {
            [MinimumNumberValidatorKey]: formatControlLabel(controlLabel) + ' must be greater than ' + controlLength,
            [MaximumNumberValidatorKey]: formatControlLabel(controlLabel) + ' must be smaller than ' + controlLength,
            [RequiredValidatorKey]: formatControlLabel(controlLabel) + ' is required.',
            [NotNullArrayValuesValidatorKey]: formatControlLabel(controlLabel) + ' is required.',
            [WhitespaceValidatorKey]: formatControlLabel(controlLabel) + ' is required.',
            [InArrayValidatorKey]: 'Wrong ' + (!controlLabel ? 'value.' : (controlLabel.toLowerCase() + ' value.')),
            [ArrayEveryValidatorKey]: 'Wrong ' + (!controlLabel ? 'value.' : (controlLabel.toLowerCase() + ' value.')),
            [PhoneValidatorKey]: 'Wrong or incorrect phone number.',
            [EmailValidatorKey]: 'Email address is invalid.',
            [UnderEighteensValidatorKey]: 'The person cannot be under 18 years old.',
            [PasswordValidatorKey]: passwordText(),
            [DuplicatedValueValidatorKey]: !controlLabel ? 'Duplicate field.' : ('Duplicate ' + controlLabel.toLowerCase() + '.'),
            [MinDateValidatorKey]: 'The date must be greater than selected.',
            [MaxDateValidatorKey]: 'The date must be less than selected.',
            [FileSizeValidatorKey]: 'The selected file is too large. Please upload an image that is less than 10MB.',
            [FileTypeValidatorKey]: 'The selected file format is unrecognized. Please check the supported file types before uploading.',
            [MinLengthValidatorKey]: formatControlLabel(controlLabel) + ' must be minimum ' + controlLength + ' symbols.',
            [MaxLengthValidatorKey]: formatControlLabel(controlLabel) + ' must be maximum ' + controlLength + ' symbols.',
            [OnlyLatinValidatorKey]: formatControlLabel(controlLabel) + ' can contain only latin letters.',
            [OnlyDigitsValidatorKey]: formatControlLabel(controlLabel) + ' can contain only digits.',
            [LatinDigitsValidatorKey]: formatControlLabel(controlLabel) + ' can contain only latin letters and digits.',
            [IbanValidatorKey]: 'IBAN is invalid.',
            [SwiftValidatorKey]: 'Bic/Swift/Routing No is invalid.',
            [OnlyCyrillicValidatorKey]: formatControlLabel(controlLabel) + ' can contain only cyrillic letters.',
            [EmailExistsValidatorKey]: 'Email address already exists in the system.',
            [BlackListedCountryValidatorKey]: 'Selected country is marked as blacklisted.',
            [AddressValidatorKey]: `${formatControlLabel(controlLabel)} must be in Latin`,
            [SortCodeValidatorKey]: 'Invalid sort code. The code should contain three couple from digits separated with dash(xx-xx-xx).',
            [InvalidAmountKey]: 'Amount must be greater than 0.00$.',
            [MaximumAmountValidatorKey]: formatControlLabel(controlLabel) + ' must be less  than or equal to ' + controlLength,
            [TaxNumberValidatorKey]: taxNumberText(),
            [LatinLettersAndSpecialSymbolsAndWhiteSpaceValidatorKey]: `${formatControlLabel(controlLabel)} must contain only Latin letters and digits and/or special symbols.`,
            [ExecutionsSymbolValidatorKey]: getExecutionsSymbolText(),
            [AmountMinValidatorKey]: formatControlLabel(controlLabel) + ' must be minimum ' + controlLength,
            [AmountMaxValidatorKey]: formatControlLabel(controlLabel) + ' must be maximum ' + controlLength,
            [CompanyNameValidatorKey]: companyNameText(),
            [NameValidatorKey]: `${formatControlLabel(controlLabel)} must contain only Latin letters and/or the symbols “-“, “ ' “`
        };
    }
}
